import { useState } from 'react';
import { RemaingCompanies, RemaningClients } from 'src/components/services/httpServices';
import { AppContext } from './app.context';

export const AppContextProvider = ({ children }) => {
  // Define state variables for clients and employers
  const [customers, setCustomers] = useState(null);
  const [employers, setEmployers] = useState([]);
  const [dataFetched, setDataFetched] = useState(false);

  const fetchEmployersAndClients = async () => {
    const savedClients = await RemaningClients();

    setCustomers(savedClients);
    const savedEmployers = await RemaingCompanies();
    setEmployers(savedEmployers);
    setDataFetched(true);
  };

  // Provide clients and employers data through the AppContext.Provider
  return (
    <AppContext.Provider value={{ customers, employers, fetchEmployersAndClients, dataFetched, setDataFetched }}>
      {children}
    </AppContext.Provider>
  );
};
